<!-- 
	This is the sign in page, it uses the dashboard layout in: 
	"./layouts/Default.vue" .
 -->

<template>
  <div class="sign-in">
    <a-row type="flex" :gutter="[24, 24]" justify="space-around" align="middle">
      <!-- Sign In Form Column -->
      <a-col
        :span="24"
        :md="12"
        :lg="{ span: 12, offset: 0 }"
        :xl="{ span: 6, offset: 2 }"
        class="col-form"
      >
        <h1 class="mb-15">Sign In</h1>
        <h5 class="font-regular text-muted">
          Enter your email and password to sign in
        </h5>

        <!-- Sign In Form -->
        <a-form
          id="components-form-demo-normal-login"
          :form="form"
          class="login-form"
          @submit="handleSubmit"
          :hideRequiredMark="true"
        >
          <a-form-item class="mb-10" label="Email" :colon="false">
            <a-input
              v-decorator="[
                'email',
                {
                  rules: [
                    { required: true, message: 'Please input your email!' },
                  ],
                },
              ]"
              placeholder="Email"
              v-model="username"
            />
          </a-form-item>
          <a-form-item class="mb-5" label="Password" :colon="false">
            <a-input
              v-decorator="[
                'password',
                {
                  rules: [
                    { required: true, message: 'Please input your password!' },
                  ],
                },
              ]"
              type="password"
              v-model="password"
              placeholder="Password"
            />
          </a-form-item>
          <a-form-item class="mb-10" v-if="false">
            <a-switch v-model="rememberMe" /> Remember Me
          </a-form-item>
          <a-form-item>
            <a-button
              type="primary"
              block
              class="login-form-button"
              v-on:click="login"
            >
              <!--html-type="submit"-->

              SIGN IN
            </a-button>
          </a-form-item>
          <a-form-item>
            <a-alert
              type="success"
              v-show="successMsg != ''"
              :message="successMsg"
              banner
            />
            <a-alert
              type="error"
              v-show="errMsg != ''"
              :message="errMsg"
              banner
            />
          </a-form-item>
        </a-form>
        <!-- / Sign In Form -->

        <p class="font-semibold text-muted" v-if="registrationIsActive">
          Don't have an account?
          <router-link to="/sign-up" class="font-bold text-dark"
            >Sign Up</router-link
          >
        </p>
      </a-col>
      <!-- / Sign In Form Column -->

      <!-- Sign In Image Column -->
      <a-col :span="24" :md="12" :lg="12" :xl="12" class="col-img">
        <svg
          version="1.1"
          id="fudev"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 209.9 192.1"
          style="enable-background: new 0 0 209.9 192.1"
          xml:space="preserve"
          width="250px"
          height="250px"
        >
          <linearGradient
            id="Path_31_1_"
            gradientUnits="userSpaceOnUse"
            x1="-850.3205"
            y1="632.4663"
            x2="-849.3205"
            y2="632.4663"
            gradientTransform="matrix(209.8521 0 0 -109.8256 178359.6562 69557.0859)"
          >
            <stop offset="0" style="stop-color: #5ac7ff" />
            <stop offset="9.700001e-02" style="stop-color: #4cb0e8" />
            <stop offset="0.281" style="stop-color: #368cc3" />
            <stop offset="0.465" style="stop-color: #2570a6" />
            <stop offset="0.647" style="stop-color: #185c91" />
            <stop offset="0.827" style="stop-color: #115085" />
            <stop offset="1" style="stop-color: #0f4c81" />
          </linearGradient>
          <path
            id="Path_31"
            class="st0"
            d="M209.9,101.2v22.2c0,6.9-3.7,13.2-9.6,16.7l-14.4,8.3c-6,3.4-13.3,3.4-19.2,0l-19.2-11.1  L80.9,98.9c-0.6-0.4-1.3-0.8-1.9-1.2L43.3,77c-5.9-3.4-13.2-3.4-19.1-0.1L24,77L0,90.9V68.7c0-6.9,3.7-13.2,9.6-16.7L24,43.7  c5.9-3.4,13.3-3.4,19.2,0l19.2,11.1L129,93.2c0.7,0.4,1.3,0.8,1.9,1.2l35.8,20.7c5.9,3.4,13.2,3.4,19.2,0l0.1,0L209.9,101.2z"
          />
          <linearGradient
            id="Path_32_1_"
            gradientUnits="userSpaceOnUse"
            x1="-849.6951"
            y1="633.412"
            x2="-849.5801"
            y2="633.001"
            gradientTransform="matrix(209.8521 0 0 -109.8256 178359.6562 69557.0859)"
          >
            <stop offset="0" style="stop-color: #000000" />
            <stop offset="0.322" style="stop-color: #000000; stop-opacity: 0" />
          </linearGradient>
          <path
            id="Path_32"
            class="st1"
            d="M209.9,101.2v22.2c0,6.9-3.7,13.2-9.6,16.7l-14.4,8.3c-6,3.4-13.3,3.4-19.2,0l-19.2-11.1  L80.9,98.9c-0.6-0.4-1.3-0.8-1.9-1.2L43.3,77c-5.9-3.4-13.2-3.4-19.1-0.1L24,77L0,90.9V68.7c0-6.9,3.7-13.2,9.6-16.7L24,43.7  c5.9-3.4,13.3-3.4,19.2,0l19.2,11.1L129,93.2c0.7,0.4,1.3,0.8,1.9,1.2l35.8,20.7c5.9,3.4,13.2,3.4,19.2,0l0.1,0L209.9,101.2z"
          />
          <linearGradient
            id="Path_33_1_"
            gradientUnits="userSpaceOnUse"
            x1="-849.4414"
            y1="632.5053"
            x2="-849.5284"
            y2="632.8143"
            gradientTransform="matrix(209.8521 0 0 -109.8256 178359.6562 69557.0859)"
          >
            <stop offset="0" style="stop-color: #000000" />
            <stop offset="0.322" style="stop-color: #000000; stop-opacity: 0" />
          </linearGradient>
          <path
            id="Path_33"
            class="st2"
            d="M209.9,101.2v22.2c0,6.9-3.7,13.2-9.6,16.7l-14.4,8.3c-6,3.4-13.3,3.4-19.2,0l-19.2-11.1  L80.9,98.9c-0.6-0.4-1.3-0.8-1.9-1.2L43.3,77c-5.9-3.4-13.2-3.4-19.1-0.1L24,77L0,90.9V68.7c0-6.9,3.7-13.2,9.6-16.7L24,43.7  c5.9-3.4,13.3-3.4,19.2,0l19.2,11.1L129,93.2c0.7,0.4,1.3,0.8,1.9,1.2l35.8,20.7c5.9,3.4,13.2,3.4,19.2,0l0.1,0L209.9,101.2z"
          />
          <linearGradient
            id="Path_34_1_"
            gradientUnits="userSpaceOnUse"
            x1="-849.4999"
            y1="631.6995"
            x2="-849.1809"
            y2="632.9745"
            gradientTransform="matrix(209.859 0 0 -90.9103 178365.6094 57568.0508)"
          >
            <stop offset="0" style="stop-color: #5ac7ff" />
            <stop offset="9.700001e-02" style="stop-color: #4cb0e8" />
            <stop offset="0.281" style="stop-color: #368cc3" />
            <stop offset="0.465" style="stop-color: #2570a6" />
            <stop offset="0.647" style="stop-color: #185c91" />
            <stop offset="0.827" style="stop-color: #115085" />
            <stop offset="1" style="stop-color: #0f4c81" />
          </linearGradient>
          <path
            id="Path_34"
            class="st3"
            d="M95.3,156.2c5.9,3.4,13.3,3.4,19.2,0l95.3-55v22.2c0,6.9-3.7,13.2-9.6,16.7l-85.7,49.5  c-5.9,3.4-13.3,3.4-19.2,0L9.6,140.1c-6-3.4-9.6-9.8-9.6-16.7v-22.2L95.3,156.2z"
          />
          <linearGradient
            id="Path_35_1_"
            gradientUnits="userSpaceOnUse"
            x1="-849.741"
            y1="630.8965"
            x2="-848.945"
            y2="631.9576"
            gradientTransform="matrix(209.859 0 0 -90.9113 178365.5938 57467.4688)"
          >
            <stop offset="0" style="stop-color: #5ac7ff" />
            <stop offset="9.700001e-02" style="stop-color: #4cb0e8" />
            <stop offset="0.281" style="stop-color: #368cc3" />
            <stop offset="0.465" style="stop-color: #2570a6" />
            <stop offset="0.647" style="stop-color: #185c91" />
            <stop offset="0.827" style="stop-color: #115085" />
            <stop offset="1" style="stop-color: #0f4c81" />
          </linearGradient>
          <path
            id="Path_35"
            class="st4"
            d="M114.5,35.9c-5.9-3.4-13.3-3.4-19.2,0L0,90.9V68.7c0-6.9,3.7-13.2,9.6-16.7L95.3,2.6  c5.9-3.4,13.3-3.4,19.2,0l85.7,49.5c6,3.4,9.6,9.8,9.6,16.7v22.2L114.5,35.9z"
          />
        </svg>
      </a-col>
      <!-- Sign In Image Column -->
    </a-row>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      // Binded model property for "Sign In Form" switch button for "Remember Me" .
      username: "",
      password: "",
      rememberMe: true,
      apps: {},
      errMsg: "",
      successMsg: "",
    };
  },
  beforeCreate() {
    // Creates the form and adds to it component's "form" property.
    this.form = this.$form.createForm(this, { name: "normal_login" });
  },
  methods: {
    ...mapMutations(["setUser", "setToken", "setRefreshToken"]),
    // Handles input validation after submission.
    handleSubmit(e) {
      e.preventDefault();
      this.errMsg = "";
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
        }
      });
    },
    login() {
      const headers = {
        app: this.$store.state.app,
        "Content-Type": "application/json",
      };

      this.errMsg = "";
      this.success = "";
      this.axios
        .post(
          "/public/auth/login",
          {
            username: this.username,
            password: this.password,
          },
          {
            headers,
          }
        )
        .then(({ data }) => {
          if (data.success) {
            this.successMsg = data.message;
            this.setToken("SIGNED_IN");
            //this.setRefreshToken(data.result.refreshJwt);
            this.setUser(data.result.user);
            setTimeout(() => {
              this.$router.push("/dashboard");
            }, 1500);
          } else if (data.name == "Error") {
            this.errMsg = data.message;
            this.$message.error(data.message);
          } else {
            this.errMsg = data.error;
            this.$message.error(data.error);
          }
        })
        .catch((error) => {
          console.log(error);
          if (error.response?.data?.message) {
            console.log(error.response?.data);
            this.errMsg = error.response.data.message;
            this.$message.error(error.response.data.message);
          } else {
            this.errMsg = error.message;
            this.$message.error(error.message);
          }
        });
    },
  },
  async mounted() {
    if (this.isLoggedIn) {
      this.$router.push("/dashboard");
    }
  },
};
</script>
<style type="text/css">
.st0 {
  fill: url(#Path_31_1_);
}
.st1 {
  opacity: 0.3;
  fill: url(#Path_32_1_);
  enable-background: new;
}
.st2 {
  opacity: 0.3;
  fill: url(#Path_33_1_);
  enable-background: new;
}
.st3 {
  fill: url(#Path_34_1_);
}
.st4 {
  fill: url(#Path_35_1_);
}
</style>

<style lang="scss">
body {
  background-color: #ffffff;
}
</style>
